var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.98 511.98",
    style: {
      enableBackground: "new 0 0 511.98 511.98"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#929292"
    },
    cx: 255.988,
    cy: 489.085,
    rx: 37.415,
    ry: 22.895
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E3BB4D"
    },
    d: "M394.278,138.286C394.278,61.911,332.363,0,255.988,0S117.702,61.911,117.702,138.286 c0,31.58,10.607,60.671,28.421,83.951h-0.024c23.22,31.214,61.983,84.477,61.983,145.196h47.905h47.909 c0-60.719,38.763-113.978,61.983-145.196h-0.028C383.671,198.957,394.278,169.865,394.278,138.286z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 198.56,
    cy: 93.619,
    r: 33.598
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 182.306,
    cy: 152.119,
    r: 12.509
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#696969"
    },
    d: "M318.714,476.805c0,7.778-6.305,14.078-14.078,14.078H206.1c-7.778,0-14.078-6.301-14.078-14.078 V374.613c0-7.778,6.305-14.078,14.078-14.078h98.531c7.778,0,14.078,6.301,14.078,14.078v102.191H318.714z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#929292"
    },
    d: "M327.8,382.026c0,5.442-4.41,10.342-9.852,10.952l-125.159,13.922 c-5.438,0.602-9.852-3.315-9.852-8.757l0,0c0-5.442,4.41-10.342,9.852-10.952l125.159-13.922 C323.385,372.667,327.8,376.588,327.8,382.026L327.8,382.026z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#929292"
    },
    d: "M327.8,417.65c0,5.438-4.41,10.342-9.852,10.948L192.789,442.52 c-5.438,0.602-9.852-3.315-9.852-8.757l0,0c0-5.438,4.41-10.342,9.852-10.948l125.159-13.922 C323.385,408.288,327.8,412.213,327.8,417.65L327.8,417.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#929292"
    },
    d: "M327.8,453.271c0,5.438-4.41,10.342-9.852,10.948l-125.159,13.922 c-5.438,0.606-9.852-3.315-9.852-8.757l0,0c0-5.438,4.41-10.342,9.852-10.948l125.159-13.922 C323.385,443.913,327.8,447.833,327.8,453.271L327.8,453.271z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.9de5614a4914be3c5adfa224baf145fa.svg";
export { ForwardRef as ReactComponent };